import React from 'react'

const Banner2 = () => {
  return (
    <section class="banner-section apropos-section">
    <div class="container position-relative h-100">
      <div class="row">
        <div class="col-lg-12">
          <div class="banner-heading">
            {/* <h1>
              Optimisez <br />
              le rendement
            </h1> */}
            <h1>	<span>Inspirons</span><br /> les  gens à </h1>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="banner-heading banner-heading-bottom">
            <h1>créer de <br /> la <span>valeur</span></h1>
            {/* <h1>
              de vos <br />
              <span> placements </span>
            </h1> */}
          </div>
        </div>
      </div>
    </div>
  </section>
  )
}

export default Banner2
